import { Prisma } from ".prisma/client"
import { get, isArray, isEmpty, map, set } from "lodash"

export default function buildSearchQuery(searchParams) {
  const result: Prisma.PipelineWhereInput = {}
  if (searchParams.option) buildForOptionFilter(result, searchParams.option)

  if (searchParams.text) buildForSearchFilter(result, searchParams.text)

  return result
}

function buildForOptionFilter(search, option) {
  search.AND = Object.entries(option).map(([filter, value]) => {
    switch (filter) {
      case "geography":
      case "brand":
        return {
          [filter]: buildNameInQuery(value, "name", "name"),
        }
      case "status":
        return {
          [filter]:
            isArray(value) && value.length
              ? { in: value?.map((status) => status["code"]) }
              : undefined,
        }
      case "language":
        return {
          [filter]: buildNameInQuery(value, "code", "code"),
        }
      case "targetSystem":
      case "githubRepositoryUrl":
      case "githubRepositoryPath":
      case "series":
        return {
          [filter]: isArray(value) && value.length ? { in: value } : undefined,
        }
      default:
        return {
          [filter]: value,
        }
    }
  })
}

function buildNameInQuery(items, name: string | null = null, key: string) {
  if (isArray(items) && !isEmpty(items)) {
    return {
      [key]: {
        in: map(items, (item) => (name ? get(item, name) : item)),
      },
    }
  }
  return undefined
}
function buildForSearchFilter(
  search,
  searchFilter: { id: string | undefined; name: string | undefined }
) {
  if (!searchFilter) return

  const { id, name } = searchFilter
  const conditions: {}[] = []

  if (id) {
    conditions.push({ id: Number(id) })
  }

  if (name) {
    const searchFields = [["name"], ["brand", "name"], ["githubRepositoryRef"]]

    const nameConditions = searchFields.map((path) => {
      const condition: any = {}
      set(condition, path, {
        contains: name,
        mode: "insensitive",
      })
      return condition
    })

    conditions.push(...nameConditions)
  }
  if (conditions.length) {
    search.AND = search.AND || []
    search.AND.push({ OR: conditions })
  }
}
